import React from "react";
import { Link } from "react-router-dom";
import Context from "../../../Context";
import EssenceReference from "../../Essence/EssenceReference";

export default class ManualCrumbs extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = { showStructureReference: false, pending: false };
  }
  changeStart = () => {
    this.setState({ showStructureReference: true });
  };
  referenceOnHide = () => {
    this.setState({ showStructureReference: false });
  };
  referenceOnSelect = async (item) => {
    if (item.id) {
      this.setState({ pending: true });
      if (this.props.mode === "add") {
        document.location.href = `/manual/${item.id}/${this.props.document}/add/`;
      }
      if (this.props.mode === "edit") {
        let ask = await this.context.ask(
          `Вы действительно хотите изменить положение документа в структуре документации на "${item.name}"`,
          "Перенести документ?",
          "question"
        );
        if (ask.value) {
          let result = await this.context.api.q("/manual/set", {
            id: this.props.document,
            structure: item.id,
          });

          if (result) {
            document.location.href = `/manual/${item.id}/${this.props.document}/edit/`;
          } else {
            this.context.toast(
              "Не удалось изменить положение документа в структуре документации",
              "waring"
            );
          }
        } else {
          this.setState({ pending: false });
        }
      }
    }
  };
  render() {
    let crumbs = null;
    const items = this.props.items || {};

    let canChange =
      this.props.mode === "add" || this.props.mode === "edit" ? true : false;

    if (Array.isArray(this.props.path)) {
      crumbs = (
        <div className="breadcrumbs">
          <Link
            to={this.props.baseUrl}
            className="text-muted  text-hover-dark-75"
          >
            <i className="flaticon2-document   mr-2"></i>
          </Link>
          {this.props.path.length === 0 ? (
            <>
              {canChange ? (
                <span
                  onClick={() => this.changeStart()}
                  className="text-hover-primary cursor-pointer"
                >
                  Необходимо выбрать раздел документации{" "}
                </span>
              ) : (
                <Link
                  className="mr-2 text-dark-50 text-hover-dark-75"
                  to={this.props.baseUrl}
                >
                  {this.props.baseName}
                </Link>
              )}{" "}
            </>
          ) : null}
          {this.props.path.map((itemId, index) => {
            const item = items[`_${itemId}`];
            return (
              <span key={itemId}>
                <Link
                  className="mr-2 text-dark-50 text-hover-dark-75"
                  key={itemId}
                  to={`${this.props.baseUrl}/${item.id}/`}
                >
                  {item.name}
                </Link>
                {index + 1 < this.props.path.length ? (
                  <i className="fa fa-angle-right mr-2 text-dark-25"></i>
                ) : null}
              </span>
            );
          })}
          {canChange ? (
            <>
              <span
                title="Изменить место документа в структуре"
                onClick={() => this.changeStart()}
                className="cursor-pointer px-2 ml-2 text-hover-primary text-muted flaticon2-edit px-2 align-middle"
              ></span>
            </>
          ) : null}
          {this.state.pending ? (
            <div className="d-inline-block spinner"></div>
          ) : null}
        </div>
      );
    }
    return (
      <>
        {crumbs}
        {this.state.showStructureReference ? (
          <EssenceReference
            essence="structure"
            title="Структура документации"
            forceType="ism.structure"
            showDescription
            structure
            show={this.state.showStructureReference}
            onHide={this.referenceOnHide}
            onSelect={this.referenceOnSelect}
          />
        ) : null}
      </>
    );
  }
}
